var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src4078178155/src/~/core-js/library/modules/_cof.js
// module id = nKkP
// module chunks = 6